import enLang from './entries/en_US';
import arLang from './entries/ar_EG';
import frLang from './entries/fr_FR';
import jaLang from './entries/ja_JP'

const AppLocale = {
    en: enLang,
    //zh: zhLang,
    fr: frLang,
    ar: arLang
};

export default AppLocale;